import { Pipe, PipeTransform } from '@angular/core';

export enum SortingDirection {
    'asc' = 1,
    'desc' = -1,
}

@Pipe({
  name: "sortByDate"
})
export class SortByDatePipe implements PipeTransform {
  transform(array: any, arg1: string, arg2: string): any {

    if (!array || array.length < 2) {
      return array;
    }

    if (!arg1 || !arg2 ) {
          return array;
    }

    if (!(arg2 in SortingDirection)) {
      return array;
    }

     array.sort((a, b) => {
        a = new Date(a[arg1]);
        b = new Date(b[arg1]);

       if (a < b) { return  (1 * SortingDirection[arg2]); }
       else if (a > b) { return (-1 * SortingDirection[arg2]); }
       else { return 0; }
    });

    return array;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/pipes/sort-by-date.pipe.ts